import { Button, cn } from "@tellescope/ui";
import { ReactNode } from "react";
import { useNavbarShallowStore } from "../store";
import { PanelLeft } from "lucide-react";
import { PAGE_HEADER_HEIGHT_CLASSES } from "../constants/header-sizing";

export interface PageTabsHeaderProps {
  children?: ReactNode;
  className?: string;
}

export const PageTabsHeader = ({ children, className }: PageTabsHeaderProps) => {
  const { isCollapsed, toggleCollapsed } = useNavbarShallowStore("isCollapsed", "toggleCollapsed");

  return (
    <div
      className={cn(
        "flex items-center pl-2 w-full border-b border-b-gray-200 flex-shrink-0",
        PAGE_HEADER_HEIGHT_CLASSES,
        className
      )}
    >
      <Button
        variant="ghost"
        size="icon"
        className="w-9 h-9 rounded-md shrink-0"
        onClick={toggleCollapsed}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <PanelLeft className="h-5 w-5" />
      </Button>
      <div className="h-full w-full [&_[role=tablist]]:border-b-0">{children}</div>
    </div>
  );
};
